import type { Language } from "@ctypes";

export const supportedLanguages: Language[] = [
  { key: "en", name: "English" },
  { key: "es", name: "Spanish" },
  { key: "ru", name: "Russian" },
  { key: "fr", name: "French" },
  { key: "de", name: "German" },
  { key: "it", name: "Italian" },
  { key: "ja", name: "Japanese" },
  { key: "pl", name: "Polish" },
  { key: "zh", name: "Chinese Simplified" },
  { key: "pt", name: "Portuguese, Brazilian" },
  { key: "uk", name: "Ukrainian" },
];
